import {useEffect} from 'react'
import {Ga4Data, ga4} from 'utils/ga4'

type Options = {
  enabled?: boolean
}

export const useGa4MountEffect = (data: Ga4Data, options: Options = {enabled: true}) => {
  const {enabled} = options

  return useEffect(() => {
    if (!enabled) {
      return
    }

    ga4(data)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [JSON.stringify(data), enabled])
}
